import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon, MailIcon, ChevronDownIcon, FacebookIcon, InstagramIcon, YoutubeIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const programLinks = [{
  label: 'Early Skillz (Ages 3–4)',
  href: '#programs'
}, {
  label: 'Basic Skillz (Ages 5–6)',
  href: '#programs'
}, {
  label: 'Core Skillz (Ages 7–9)',
  href: '#programs'
}, {
  label: 'Teen & Adult (Ages 10+)',
  href: '#programs'
}, {
  label: 'Spectrum Skillz',
  href: '#programs'
}, {
  label: 'Birthday Parties',
  href: '/birthday-parties'
}];
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [programsOpen, setProgramsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileOpen]);
  return <>
      {/* Utility bar */}
      <div className="bg-navy-950 text-white/70 text-xs hidden md:block" data-id="element-222">
        <div className="max-w-7xl mx-auto px-6 py-2 grid grid-cols-3 items-center" data-id="element-223">
          {/* Social icons — left */}
          <div className="flex items-center gap-3" data-id="element-224">
            <a href="#" aria-label="Facebook" className="hover:text-white transition-colors" data-id="element-225">
              <FacebookIcon className="w-3.5 h-3.5" data-id="element-226" />
            </a>
            <a href="#" aria-label="Instagram" className="hover:text-white transition-colors" data-id="element-227">
              <InstagramIcon className="w-3.5 h-3.5" data-id="element-228" />
            </a>
            <a href="#" aria-label="YouTube" className="hover:text-white transition-colors" data-id="element-229">
              <YoutubeIcon className="w-3.5 h-3.5" data-id="element-230" />
            </a>
          </div>

          {/* Service Area — center */}
          <div className="text-center font-medium text-white/80 hidden lg:block whitespace-nowrap" data-id="element-231">
            Kids &amp; Adult Taekwondo Near Colleyville, Hurst, Bedford &amp;
            the Mid-Cities
          </div>
          <div className="text-center font-medium text-white/80 lg:hidden whitespace-nowrap" data-id="element-232">
            Taekwondo Near Colleyville &amp; the Mid-Cities
          </div>

          {/* Contact — right */}
          <div className="flex items-center justify-end gap-6" data-id="element-233">
            <a href="mailto:ntacolleyville@gmail.com" className="flex items-center gap-1.5 hover:text-white transition-colors" data-id="element-234">
              <MailIcon className="w-3 h-3" data-id="element-235" />
              <span className="hidden xl:inline" data-id="element-236">ntacolleyville@gmail.com</span>
            </a>
            <a href="tel:817-581-1419" className="flex items-center gap-1.5 hover:text-white transition-colors font-semibold" data-id="element-237">
              <PhoneIcon className="w-3 h-3" data-id="element-238" />
              817-581-1419
            </a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <header className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${scrolled ? 'shadow-md' : 'shadow-sm'}`} data-id="element-239">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-240">
          <div className="flex items-center justify-between h-16 md:h-[72px]" data-id="element-241">
            {/* Logo */}
            <a href="/" className="flex items-center shrink-0" aria-label="NTA Taekwondo Home" data-id="element-242">
              <img src="https://cdn.magicpatterns.com/uploads/63qskYt7Y9VwXpzp85HiTx/NTA-Colleyville-Taekwondo.webp" alt="NTA Taekwondo — Colleyville, TX" className="h-12 md:h-14 w-auto" data-id="element-243" />
            </a>

            {/* Desktop nav */}
            <nav className="hidden lg:flex items-center gap-1" aria-label="Main navigation" data-id="element-244">
              <a href="/" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-245">
                Home
              </a>
              <a href="#reviews" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-246">
                Reviews
              </a>
              {/* Programs dropdown */}
              <div className="relative" onMouseEnter={() => setProgramsOpen(true)} onMouseLeave={() => setProgramsOpen(false)} data-id="element-247">
                <button className="flex items-center gap-1 px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" aria-expanded={programsOpen} aria-haspopup="true" onClick={() => setProgramsOpen(!programsOpen)} data-id="element-248">
                  Programs
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${programsOpen ? 'rotate-180' : ''}`} data-id="element-249" />
                </button>
                <AnimatePresence data-id="element-250">
                  {programsOpen && <motion.div initial={{
                  opacity: 0,
                  y: 8
                }} animate={{
                  opacity: 1,
                  y: 0
                }} exit={{
                  opacity: 0,
                  y: 8
                }} transition={{
                  duration: 0.15
                }} className="absolute top-full left-0 mt-1 w-56 bg-white rounded-xl shadow-lg border border-warm-200 py-2 z-50" data-id="element-251">
                      {programLinks.map(link => <a key={link.label} href={link.href} className="block px-4 py-2.5 text-sm text-ink hover:bg-warm-100 hover:text-navy-950 transition-colors" data-id="element-252">
                          {link.label}
                        </a>)}
                    </motion.div>}
                </AnimatePresence>
              </div>
              <a href="#summer-camp" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-253">
                Summer Camp
              </a>
              <a href="#location" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-254">
                Location
              </a>
              <a href="#about" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-255">
                About
              </a>
              <a href="#blog" className="px-4 py-2 text-sm font-medium text-ink hover:text-navy-950 transition-colors rounded-lg" data-id="element-256">
                Blog
              </a>
            </nav>

            {/* Desktop CTA + Mobile toggle */}
            <div className="flex items-center gap-3" data-id="element-257">
              <a href="#cta" className="hidden md:inline-flex items-center px-5 py-2.5 bg-amber text-navy-950 text-sm font-bold rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2" data-id="element-258">
                Contact Us
              </a>
              <button className="lg:hidden p-2 text-navy-950 hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-259">
                {mobileOpen ? <XIcon className="w-6 h-6" data-id="element-260" /> : <MenuIcon className="w-6 h-6" data-id="element-261" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        <AnimatePresence data-id="element-262">
          {mobileOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.25
        }} className="lg:hidden overflow-hidden bg-white border-t border-warm-200" data-id="element-263">
              <nav className="px-4 py-4 space-y-1" aria-label="Mobile navigation" data-id="element-264">
                {/* Prominent tap-to-call */}
                <a href="tel:817-581-1419" className="flex items-center justify-center gap-2 px-5 py-3.5 bg-navy-950 text-white font-bold rounded-lg hover:bg-navy-900 transition-colors mb-4" data-id="element-265">
                  <PhoneIcon className="w-4 h-4" data-id="element-266" />
                  Call 817-581-1419
                </a>

                <a href="/" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-267">
                  Home
                </a>
                <a href="#reviews" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-268">
                  Reviews
                </a>
                <div className="border-t border-warm-200 my-3" data-id="element-269" />
                <p className="px-3 py-2 text-xs font-bold uppercase tracking-wider text-ink-muted" data-id="element-270">
                  Programs
                </p>
                {programLinks.map(link => <a key={link.label} href={link.href} className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-271">
                    {link.label}
                  </a>)}
                <div className="border-t border-warm-200 my-3" data-id="element-272" />
                <a href="#summer-camp" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-273">
                  Summer Camp
                </a>
                <a href="#location" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-274">
                  Location
                </a>
                <a href="#about" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-275">
                  About
                </a>
                <a href="#blog" className="block px-3 py-3 text-base font-medium text-ink hover:bg-warm-100 rounded-lg transition-colors" onClick={() => setMobileOpen(false)} data-id="element-276">
                  Blog
                </a>
                <div className="border-t border-warm-200 my-3" data-id="element-277" />
                <div className="flex flex-col gap-3 px-3 pt-2 pb-1" data-id="element-278">
                  <a href="#cta" className="flex items-center justify-center px-5 py-3 bg-amber text-navy-950 font-bold rounded-lg hover:bg-amber-light transition-colors text-center" onClick={() => setMobileOpen(false)} data-id="element-279">
                    Contact Us
                  </a>
                </div>
                {/* Social icons */}
                <div className="flex items-center justify-center gap-5 pt-4 pb-2" data-id="element-280">
                  <a href="#" aria-label="Facebook" className="text-ink-muted hover:text-navy-950 transition-colors" data-id="element-281">
                    <FacebookIcon className="w-5 h-5" data-id="element-282" />
                  </a>
                  <a href="#" aria-label="Instagram" className="text-ink-muted hover:text-navy-950 transition-colors" data-id="element-283">
                    <InstagramIcon className="w-5 h-5" data-id="element-284" />
                  </a>
                  <a href="#" aria-label="YouTube" className="text-ink-muted hover:text-navy-950 transition-colors" data-id="element-285">
                    <YoutubeIcon className="w-5 h-5" data-id="element-286" />
                  </a>
                </div>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </header>
    </>;
}